// TODO probably name this something other than blocks to reduce confusion (since it's not draft-js blocks here)
export function getPhotoBlocks (photos) {
  const photoGroups = collectPhotosAlongRoute(photos)
  const blocks = []
  photoGroups.forEach(group => {
    if (group.length < 6) {
      blocks.push({
        type: 'gallery',
        imageIds: group.map(photo => photo.id),
        displayAsPostcard: true
      })
    } else {
      blocks.push({
        type: 'gallery',
        imageIds: group.map(photo => photo.id)
      })
    }
  })
  return blocks
}

// group all photos taken within x seconds of each other
function collectPhotosAlongRoute (photos) {
  const GROUP_TIME = 5 * 60

  const photoGroups = []
  let lastPhotoGroup = []
  let lastPhoto

  photos.sort((a, b) => a.capturedI - b.capturedI).forEach(photo => {
    if (lastPhoto && ((photo.capturedI - lastPhoto.capturedI) > GROUP_TIME)) {
      photoGroups.push(lastPhotoGroup)
      lastPhotoGroup = []
    }
    lastPhotoGroup.push(photo)
    lastPhoto = photo
  })
  if (lastPhotoGroup.length) photoGroups.push(lastPhotoGroup)
  return photoGroups
}
